export const navMobile = () => {
    const burguer = document.querySelector(".hamburguer");
    const nav = document.querySelector(".nav-links");

    burguer.addEventListener("click", () => {
        nav.classList.toggle("nav-active");
        burguer.classList.toggle("active-burguer");
    });

    document.onclick = e => {
        if (e.target !== burguer && e.target !== nav) {
            nav.classList.remove("nav-active");
            burguer.classList.remove("active-burguer");
        }
    };
};

export const scrollBar = () => {
    window.onscroll = () => {
        scrollFunction();
    };

    const scrollFunction = () => {
        if (
            document.body.scrollTop > 132 ||
            document.documentElement.scrollTop > 132
        ) {
            document.getElementById("scroll-menu").style.top = "0";
        } else {
            document.getElementById("scroll-menu").style.top = "-90px";
        }
    };
};

export const smoothScroll = () => {
    $("a").on("click", function(event) {
        if (this.hash !== "") {
            event.preventDefault();
            var hash = this.hash;
            $("html, body").animate(
                {
                    scrollTop: $(hash).offset().top
                },
                300,
                function() {
                    window.location.hash = hash;
                }
            );
        }
    });
};
